import { ErrorName } from '@/core/shared/errors/enums/error-name.enum';

export function isAbortError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'name' in error &&
    (error as { name?: unknown }).name === ErrorName.ABORT_ERROR
  );
}
